import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookSquareGradient: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 60}
    id={id}
    stroke={stroke}
    viewBox='0 0 64 60'
    width={width || 64}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M31.6638 60L54.1768 55.2998L53.2514 50.8804L31.643 55.3831L10.0347 50.8804L9.11963 55.2998L31.6222 60H31.6326H31.643H31.6638Z'
      fill='url(#paint0_linear_2208_4770)'
    />
    <path
      d='M4.22185 3.72271H14.2981L13.7158 0.759094H0V3.72271H4.22185Z'
      fill='url(#paint1_linear_2208_4770)'
    />
    <path
      d='M11.2929 12.052L10.6898 9.05719H4.22185H0V12.052H4.22185H11.2929Z'
      fill='url(#paint2_linear_2208_4770)'
    />
    <path
      d='M13.7158 17.6153H4.22185H0V20.5477H14.3293L13.7158 17.6153Z'
      fill='url(#paint3_linear_2208_4770)'
    />
    <path
      d='M29.6673 20.5477H27.6915L26.818 19.2686C25.5806 20.3605 24.2184 20.9012 22.7418 20.9012C20.5477 20.9012 18.8111 20.2357 17.5425 18.9047C16.2738 17.5737 15.6395 15.7747 15.6395 13.5078C15.6395 12.0312 15.9307 10.7314 16.5026 9.60831C17.0745 8.48526 17.9064 7.61179 18.9879 6.98787C20.0797 6.36395 21.3692 6.05199 22.8562 6.05199C23.3241 6.05199 23.8128 6.13518 24.3432 6.30156C24.8631 6.46794 25.3726 6.69671 25.8614 6.98787V0.322355L29.6777 0V20.5581L29.6673 20.5477ZM22.8874 17.6672C23.3969 17.6672 23.8856 17.5737 24.3536 17.3761C24.8319 17.1785 25.331 16.8873 25.851 16.5026V10.4714C25.3414 10.0451 24.8631 9.74351 24.3952 9.55633C23.9272 9.36916 23.4281 9.27556 22.877 9.27556C21.8475 9.27556 21.0364 9.6707 20.4333 10.4506C19.8302 11.2409 19.5286 12.2496 19.5286 13.4974C19.5286 14.7452 19.8198 15.7435 20.4125 16.513C21.0052 17.2825 21.8267 17.6672 22.877 17.6672H22.8874Z'
      fill='url(#paint4_linear_2208_4770)'
    />
    <path
      d='M38.8701 17.8752C39.5252 17.8752 40.1491 17.7296 40.7314 17.4281C41.3137 17.1265 41.9585 16.721 42.6552 16.2218V6.43674H46.4403V20.558H43.9654L43.3207 19.0399C42.4472 19.6638 41.5113 20.1421 40.5234 20.4957C39.5356 20.8492 38.6517 21.0156 37.8718 21.0156C36.0832 21.0156 34.8354 20.5061 34.1179 19.4974C33.4004 18.4887 33.0364 17.0849 33.0364 15.2756V6.42633H36.8215V15.0988C36.8215 15.9723 36.9983 16.6482 37.3623 17.1369C37.7262 17.6256 38.2254 17.8648 38.8597 17.8648L38.8701 17.8752Z'
      fill='url(#paint5_linear_2208_4770)'
    />
    <path
      d='M24.104 44.6829C22.5858 44.6829 21.2652 44.3813 20.1317 43.7782C18.9983 43.1751 18.1144 42.3224 17.5009 41.1993C16.877 40.0867 16.565 38.7765 16.565 37.279C16.565 35.7816 16.877 34.4714 17.5009 33.3484C18.1248 32.2253 18.9983 31.3518 20.1317 30.7383C21.2652 30.1248 22.5962 29.8232 24.104 29.8232C25.6118 29.8232 26.9428 30.1248 28.0763 30.7279C29.2097 31.331 30.0936 32.1837 30.7071 33.3068C31.331 34.4194 31.643 35.7296 31.643 37.227C31.643 38.7244 31.331 40.0347 30.7071 41.1577C30.0832 42.2808 29.2097 43.1543 28.0763 43.7678C26.9428 44.3813 25.6118 44.6829 24.104 44.6829ZM27.7435 37.227C27.7435 36 27.4004 35.0017 26.7245 34.2322C26.0485 33.4523 25.1751 33.0676 24.104 33.0676C23.0329 33.0676 22.1907 33.4627 21.494 34.2634C20.8076 35.0641 20.4645 36.0728 20.4645 37.2894C20.4645 38.5061 20.8076 39.5147 21.4835 40.2842C22.1595 41.0641 23.0329 41.4489 24.104 41.4489C25.1751 41.4489 26.0173 41.0537 26.714 40.253C27.4004 39.4627 27.7435 38.4437 27.7435 37.227Z'
      fill='url(#paint6_linear_2208_4770)'
    />
    <path
      d='M40.6378 44.6829C39.1196 44.6829 37.799 44.3813 36.6655 43.7782C35.5321 43.1751 34.6482 42.3224 34.0347 41.1993C33.4108 40.0867 33.0988 38.7765 33.0988 37.279C33.0988 35.7816 33.4108 34.4714 34.0347 33.3484C34.6586 32.2253 35.5321 31.3518 36.6655 30.7383C37.799 30.1248 39.13 29.8232 40.6378 29.8232C42.1456 29.8232 43.4766 30.1248 44.6101 30.7279C45.7435 31.331 46.6274 32.1837 47.2409 33.3068C47.8649 34.4194 48.1768 35.7296 48.1768 37.227C48.1768 38.7244 47.8649 40.0347 47.2409 41.1577C46.617 42.2808 45.7435 43.1543 44.6101 43.7678C43.4766 44.3813 42.1456 44.6829 40.6378 44.6829ZM44.2773 37.227C44.2773 36 43.9342 35.0017 43.2583 34.2322C42.5824 33.4523 41.7089 33.0676 40.6378 33.0676C39.5668 33.0676 38.7245 33.4627 38.0278 34.2634C37.3415 35.0641 36.9983 36.0728 36.9983 37.2894C36.9983 38.5061 37.3415 39.5147 38.0174 40.2842C38.6933 41.0641 39.5668 41.4489 40.6378 41.4489C41.7089 41.4489 42.5512 41.0537 43.2479 40.253C43.9342 39.4627 44.2773 38.4437 44.2773 37.227Z'
      fill='url(#paint7_linear_2208_4770)'
    />
    <path
      d='M54.5615 39.7019V44.3293H50.8076V24.0936L54.5615 23.7712V35.3553L60.6135 29.792L62.7348 32.4749L58.773 35.9376L63.9515 44.3189H59.6152L56.0589 38.3501L54.5407 39.6915L54.5615 39.7019Z'
      fill='url(#paint8_linear_2208_4770)'
    />
    <path
      d='M12.052 33.5875C13.4662 32.4853 14.1733 31.3102 14.1733 30.0624C14.1733 28.1595 13.6014 26.766 12.4576 25.8718C11.3137 24.9775 9.72272 24.5303 7.68459 24.5303H0V27.6707H7.13345C8.14212 27.6707 8.90123 27.8579 9.42116 28.2218C9.93069 28.5858 10.1906 29.2201 10.1906 30.1144C10.1906 30.9255 9.85789 31.5494 9.20278 31.9653C8.54767 32.3813 7.66378 32.5893 6.55113 32.5893H0V35.6465H8.09014C9.03641 35.6465 9.79551 35.896 10.3466 36.4056C10.8978 36.9151 11.1785 37.6222 11.1785 38.5269C11.1785 39.3795 10.877 40.0451 10.2738 40.5026C9.67072 40.9705 8.85964 41.1993 7.83017 41.1993H0V44.3189H8.12133C10.253 44.3189 11.9584 43.799 13.2166 42.7591C14.4749 41.7192 15.1092 40.2946 15.1092 38.4957C15.1092 36.2808 14.0901 34.6482 12.052 33.5771V33.5875Z'
      fill='url(#paint9_linear_2208_4770)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2208_4770'
        x1='-18.8423'
        y1='42.6967'
        x2='56.9117'
        y2='58.4507'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2208_4770'
        x1='-9.71231'
        y1='-1.20625'
        x2='66.0416'
        y2='14.5476'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2208_4770'
        x1='-11.4281'
        y1='7.06065'
        x2='64.3259'
        y2='22.8145'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2208_4770'
        x1='-13.0711'
        y1='14.9324'
        x2='62.6933'
        y2='30.6968'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_2208_4770'
        x1='-10.565'
        y1='2.90121'
        x2='65.1889'
        y2='18.6655'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_2208_4770'
        x1='-10.5546'
        y1='2.84921'
        x2='65.1994'
        y2='18.6031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_2208_4770'
        x1='-15.9723'
        y1='28.9185'
        x2='59.7817'
        y2='44.6724'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_2208_4770'
        x1='-15.2859'
        y1='25.6222'
        x2='60.468'
        y2='41.3761'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_2208_4770'
        x1='-14.1525'
        y1='20.1525'
        x2='61.6014'
        y2='35.9064'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_2208_4770'
        x1='-16.2323'
        y1='30.1352'
        x2='59.5321'
        y2='45.8891'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
    </defs>
  </svg>
)

export default EdubookSquareGradient
